require('./regular/index');
require('./modules/index');
import noUiSlider from 'nouislider';
window.noUiSlider = noUiSlider



// WEBPACK FOOTER //
// ./resources/assets/js/app.js